import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { INVOICE_BUMMER_ITEMS, RESET_BUMMER_INVOICE } = LOCAL;

export default {
	namespaced: true,
	state: {
		insured: {},
		uninsured: {},
	},
	getters: {
		state: (state, getters, rootState) => rootState.game.bummers.active,
		insurancePays: (state, getters) => Object.values(state.insured).reduce(getters.total, 0),
		youPay: (state, getters) => Object.values(state.uninsured).reduce(getters.total, 0),
		total: () => (total, report) => total + report.prices.reduce(
			(reportTotal, price) => reportTotal + price.cost, 0
		),
	},
	actions: {
		initialize({ dispatch, rootState }) {
			rootState.game.bummers.active.damages.forEach(async (damage) => {
				if (!damage.requires_addon) {
					await dispatch(`game/plans/${damage.type}/${damage.coverage}/calculate`, damage, ROOT_FLAG);
				}
				await dispatch("invoice", damage);
			});
		},
		complete({ dispatch, commit, rootState, rootGetters }) {
			rootState.game.bummers.active.damages.forEach((damage) => {
				if (!damage.requires_addon) {
					dispatch(`game/plans/${damage.type}/${damage.coverage}/pay`, damage, ROOT_FLAG);
				} else if (!rootGetters[`game/plans/${damage.type}/hasAddon`](damage.required_addon)) {
					dispatch(`game/balance/withdraw`, { amount: damage.cost }, ROOT_FLAG);
				}
				commit(RESET_BUMMER_INVOICE);
			});
		},
		invoice({ commit, rootGetters }, damage) {
			if (damage.requires_addon) {
				const addon = damage.required_addon;
				commit(INVOICE_BUMMER_ITEMS, {
					type: rootGetters[`game/plans/${damage.type}/hasAddon`](addon) ? "insured" : "uninsured",
					label: damage.title,
					toPay: damage.cost,
					message: rootGetters[`game/plans/${damage.type}/addonMessage`](addon),
				});
			} else {
				commit(INVOICE_BUMMER_ITEMS, {
					type: "insured",
					...rootGetters[`game/plans/${damage.type}/${damage.coverage}/insured`],
					label: damage.title,
				});
				commit(INVOICE_BUMMER_ITEMS, {
					type: "uninsured",
					...rootGetters[`game/plans/${damage.type}/${damage.coverage}/uninsured/deductible`],
				});
				commit(INVOICE_BUMMER_ITEMS, {
					type: "uninsured",
					...rootGetters[`game/plans/${damage.type}/${damage.coverage}/uninsured/overage`],
				});
				commit(INVOICE_BUMMER_ITEMS, {
					type: "uninsured",
					...rootGetters[`game/plans/${damage.type}/${damage.coverage}/uninsured/coverageGap`],
				});
			}
		},
	},
	mutations: {
		[INVOICE_BUMMER_ITEMS](state, invoice) {
			const report = state[invoice.type][invoice.id] || { prices: [], messages: [] };

			report.title = invoice.title;
			report.prices.push({ label: invoice.label, cost: invoice.toPay });
			report.messages = invoice.message ? [...report.messages, invoice.message] : [...report.messages];

			state[invoice.type] = { ...state[invoice.type], [invoice.id]: report };
		},
		[RESET_BUMMER_INVOICE](state) {
			state.insured = {};
			state.uninsured = {};
		},
	},
};
